import React, { useRef } from 'react';
import styled from 'styled-components';
import { ColorBrandBlue1, ColorNeutralWhite } from 'autogen/design-tokens/tokens';
import Icon from 'components/Icon';
import StatusIndicator from 'components/shared/statusIndicator';
import { popup } from 'modules/helpers/animations';
import { zIndex } from 'variables/layers';
import { useChatStore } from './ChatStore';
import { dialog } from './chatConstants';
import { AnimatedHeroCTA } from './heroCTA';

// #region Styles

const Wrapper = styled.div`
    position: fixed;
    height: 80px;
    bottom: 14px;
    right: 14px;
    display: flex;
    align-items: flex-end;
    z-index: ${zIndex.fixed + 1};
`;

const Button = styled.button`
    position: relative;
    height: 62px;
    width: 62px;
    padding: 0;
    background: ${ColorBrandBlue1};
    color: ${dialog.textColor};
    font-weight: bold;
    border: 0;
    border-radius: 50%;
    z-index: ${zIndex.fixed};
    animation: ${popup} 0.5s cubic-bezier(0.215, 0.61, 0.355, 1);

    &:focus {
        outline: none;
    }
`;

const FlexCenter = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    height: inherit;
    align-items: center;
    height: 100%;
    line-height: 1.2;
`;

const Text = styled.div`
    padding: 5px 10px 0;
`;

const StyledCloseIcon = styled(Icon)`
    path {
        fill: ${ColorNeutralWhite};
    }
`;

const StyledChatIcon = styled(Icon)`
    path {
        fill: ${ColorNeutralWhite};
    }
`;

// #endregion Styles

interface IChatButtonProps {
    toggleChat: () => void;
    chatOpen: boolean;
}

function ChatButton(props: IChatButtonProps) {
    const { toggleChat, chatOpen } = props;
    const isChatOnline = useChatStore((state) => state.isOnline);
    const buttonRef = useRef(null);

    return (
        <>
            <Wrapper>
                <AnimatedHeroCTA />
                <Button type="button" onClick={toggleChat} ref={buttonRef}>
                    {isChatOnline && <StatusIndicator left={45} />}
                    <FlexCenter>
                        {chatOpen ? (
                            <StyledCloseIcon type="Close" size={24} />
                        ) : (
                            <StyledChatIcon type="Chat" size={24} />
                        )}
                    </FlexCenter>
                </Button>
            </Wrapper>
        </>
    );
}

export default ChatButton;
